import type { DriveStatus } from '@qse/constants'
import { ModelControlEnum } from '@qse/constants'
import { useActiveModelStore } from '@qse/stores'
import { useEffect } from 'react'

interface UseDriveSetupProps {
  driveStatus?: DriveStatus
}

/**
 * Custom hook to handle drive setup modal
 * Opens the modal when drive is not ready
 */
export const useDriveSetup = ({ driveStatus }: UseDriveSetupProps) => {
  const { toggleModel, modelActive } = useActiveModelStore()

  useEffect(() => {
    const needsSetup = driveStatus && driveStatus !== 'READY'

    if (needsSetup && !toggleModel) {
      useActiveModelStore.setState({
        data: {
          modalHeader: null,
          onBeforeClose: () => false, // Prevent modal from closing
        },
        width: 'max-w-md',
        modelActive: ModelControlEnum.DRIVE_SETUP,
        toggleModel: true,
        scrollBehavior: 'inside',
      })
    } else if (!needsSetup && toggleModel && modelActive === ModelControlEnum.DRIVE_SETUP) {
      // Only close the modal if the currently active modal is DRIVE_SETUP
      useActiveModelStore.setState({
        toggleModel: false,
      })
    }
  }, [driveStatus, toggleModel, modelActive])

  return {
    needsSetup: driveStatus && driveStatus !== 'READY',
  }
}
